import {
  FETCH_STORE_MANAGERS_LIST,
  RESET_STORE_MANAGERS_LIST,
} from "../../constants/action.constants";

//Storage for data.
const initialState = {
  list: [],
  others: {
    total: 0,
    offset: 0,
    limit: 10,
  },
};

//Controller for the storage.
const storeManagerListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STORE_MANAGERS_LIST:
      return { list: action.payload, others: action.others };
    case RESET_STORE_MANAGERS_LIST:
      return initialState;
    default:
      return state;
  }
};

export default storeManagerListReducer;
